export default "__VITE_ASSET__CfWvMfpt__"